<template>
  <div>
    <table class="table table-hover table-sm">
      <thead>
      <tr>
        <th>#</th>
        <th>ID</th>
        <th>препарат</th>
        <th>страна</th>
        <th>всего</th>
        <th>в день</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r,i) in records">
        <td>{{ (i + 1) + (((currentPage ?? 1) - 1) * (perPage ?? 50)) }}</td>
        <td>{{ r.drug_id }}</td>
        <td>{{ r.title }}</td>
        <td>{{ allCountries[r.income_country_id]?.name }}</td>
        <td>{{ r.total_qty }}</td>
        <td>{{ Math.round(r.total_qty / +(days ?? 1)) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: ['records', 'currentPage', 'perPage', 'days'],
  data() {
    return {
      allCountries: {},
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    this.allCountries = this.$AllCountries.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
  }
}

</script>
